/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionhistoryempty2Inputs */

const en_actionhistoryempty2 = /** @type {(inputs: Actionhistoryempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No earlier actions yet.`)
};

const de_actionhistoryempty2 = /** @type {(inputs: Actionhistoryempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine früheren Aktionen.`)
};

/**
* | output |
* | --- |
* | "No earlier actions yet." |
*
* @param {Actionhistoryempty2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionhistoryempty2 = /** @type {((inputs?: Actionhistoryempty2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionhistoryempty2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionhistoryempty2(inputs)
	return de_actionhistoryempty2(inputs)
});
export { actionhistoryempty2 as "actionHistoryEmpty" }